import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import image from '../../../img/other/graph_participation_congrats.png';
import logo from '../../../img/logo/logo_light.svg';
import PrivacyPolicyLink from '../../shared/components/PrivacyPolicyLink';

const styles = theme => ({
  root: {
    display: 'flex', 
    justifyContent: 'space-around', 
    alignItems: 'stretch', 
    flexFlow: 'column wrap'
  },
  item: {
    flexBasis: 'initial',
    flexGrow: 1,
    display: 'inline-flex'
  },
  buttonIndigo: theme.custom.button.indigo,
  logoContainer: {
    flexGrow: 1, 
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  main: {
    //height: 'calc(100vh - 75px)',
    height: '100vh',
    [theme.breakpoints.up('md')]: {
      maxWidth: 500,
      margin: '0 auto'
    }
  },
  box1: {
    flexGrow: 1, 
    alignItems: 'center', 
    flexFlow: 'column', 
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      flexGrow: 2,
      justifyContent: 'flex-end',
    }
  },
  box2: {
    flexGrow: 3, 
    alignItems: 'center', 
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      flexGrow: 1
    }
  },
  box3: {
    flexGrow: 1, 
    alignItems: 'flex-end', 
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      flexGrow: 1,
      alignItems: 'flex-start', 
    }
  },
  box4: {
    flexGrow: 1, 
    alignItems: 'flex-end', 
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      flexGrow: 1,
      alignItems: 'flex-start',
    }
  },
  box5: {
    flexGrow: 1, 
    alignItems: 'flex-end', 
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      flexGrow: 2,
      alignItems: 'flex-start',
    }
  },
  box6: {
    flexGrow: 1, 
    alignItems: 'flex-end', 
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      flexGrow: 1
    }
  },
})

class AccountMedicalInformationCreated extends React.PureComponent {

  render() {
    const { email, classes } = this.props;
    return (
      <main className={classes.main}>
        <Grid container className={classes.root} spacing={8} alignItems="center">

          <Grid item xs={12} className={classNames(classes.item, classes.logoContainer)}>
            <img src={logo} style={{maxHeight: 36}} />
          </Grid>

          <Grid item xs={12} className={classNames(classes.item, classes.box1)}>
            <Typography component='div' variant='headline'>
              ¡Fantástico!
            </Typography>
            <Typography component="div" variant="subheading">
              ¡Gracias por su participación!
            </Typography>
          </Grid>
          <Grid item xs={12} className={classNames(classes.item, classes.box2)}>
            <img src={image} />
          </Grid>
          <Grid item xs={12} className={classNames(classes.item, classes.box3)}>
            <Typography align="center">
              Te hemos enviado un email a <strong>{this.props.auth.email}</strong> para confirmar que tu formulario se ha enviado correctamente y validar tu email.
            </Typography>
          </Grid>
          <Grid item xs={12} className={classNames(classes.item, classes.box4)}>
            <Typography align="center">
              En las próximas semanas CosmoCare revisará tu perfil y te comunicará la cita con el doctor para poder finalizar la inscripción.
            </Typography>
          </Grid>
          <Grid item xs={12} className={classNames(classes.item, classes.box5)}>
            <Button type="submit" variant="contained" className={classes.buttonIndigo} component={Link} to="/account/home">
              Finalizar
            </Button>
          </Grid>
          <Grid item xs={12} className={classNames(classes.item, classes.box6)}>
            <PrivacyPolicyLink />
          </Grid>

        </Grid>
      </main>
    )
  }
}

export default withStyles(styles)(AccountMedicalInformationCreated);


// WEBPACK FOOTER //
// ./src/modules/account/pages/AccountMedicalInformationCreated.js